import React from 'react';
import classNames from 'classnames/bind';
import { withRouter } from 'react-router';
import { Dropdown, Container, Menu, Image } from 'semantic-ui-react';

import { connect } from 'react-redux';
import { deleteSession } from '../actions/sessions';

import '../styles/Header.css';
import icon from '../images/icon.svg';

class Header extends React.Component {
  constructor(props) {
    super(props);

    this.logout = this.logout.bind(this);
  }

  logout() {
    this.props.auth.logout();
  }

  canManageTeam(team) {
    return team.policy.update;
  }

  render() {
    if (!this.props.auth.isAuthenticated()) {
      return null;
    }

    const { currentUser, currentTeam } = this.props;
    const homeItemClassNames = {
      divided: !!currentTeam
    };

    return (
      <Container fluid className="Header">
        <Menu borderless fixed="top">
          <Menu.Item
            header
            onClick={() => this.props.history.push('/')}
            content={<Image src={icon} alt="Teampicture icon" size="mini" />}
            className={classNames('Header__item--home', homeItemClassNames)}
          />
          {currentTeam && (
            <Menu.Item
              header
              onClick={() =>
                this.props.history.push(`/team/${currentTeam.slug}`)
              }
              content={
                <React.Fragment>
                  <Image
                    avatar
                    src={currentTeam.logo_url}
                    alt={currentTeam.name}
                  />{' '}
                  {currentTeam.name}
                </React.Fragment>
              }
            />
          )}
          <Menu.Menu position="right">
            {currentTeam && this.canManageTeam(currentTeam) && (
              <Dropdown item text="Administrate">
                <Dropdown.Menu>
                  <Dropdown.Item
                    text="Team settings"
                    icon="settings"
                    onClick={() =>
                      this.props.history.push(`/team/${currentTeam.slug}/edit`)
                    }
                  />
                  <Dropdown.Item
                    text="Members list"
                    icon="users"
                    onClick={() =>
                      this.props.history.push(
                        `/team/${currentTeam.slug}/members`
                      )
                    }
                  />
                </Dropdown.Menu>
              </Dropdown>
            )}
            {currentUser && (
              <Dropdown
                item
                trigger={<Image avatar src={currentUser.avatar_url} />}
              >
                <Dropdown.Menu>
                  <Dropdown.Header
                    icon="info"
                    content={`Signed in as ${currentUser.name}`}
                  />
                  <Dropdown.Divider />
                  <Dropdown.Item
                    text="Edit Profile"
                    onClick={() => this.props.history.push('/profile/edit')}
                  />
                  <Dropdown.Divider />
                  <Dropdown.Item onClick={this.logout} text="Sign Out" />
                </Dropdown.Menu>
              </Dropdown>
            )}
          </Menu.Menu>
        </Menu>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  currentUser: state.sessions.user,
  currentTeam: state.teams.team,
  teams: state.teams.teams
});

const mapDispatchToProps = dispatch => ({
  deleteSession: () => {
    dispatch(deleteSession());
  }
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Header)
);



// WEBPACK FOOTER //
// ./src/containers/Header.js